import actionTypes from 'redux/actions/actionTypes';

export default function toggleSideNav() {
  return { type: actionTypes.TOGGLE_SIDE_NAV };
}
